// extracted by mini-css-extract-plugin
export var content = "_9UyWx";
export var image = "COjE2";
export var main = "TW+KY";